import { Component } from '@angular/core';
import { DatabaseViewSideInfo, defaultSideInfo } from '../database-view/database-view.component';
import * as _ from 'lodash';
import { ModalScreenService } from '../../services/modal-screen.service';



@Component({
  templateUrl: './main-page.html',
  styleUrls: ['./main-page.scss'],
})

export class MainPageComponent {

  rightInfo:DatabaseViewSideInfo;

  leftInfo:DatabaseViewSideInfo;


  constructor(
    private modalScreenService:ModalScreenService,
  ) {
    this.rightInfo = _.clone(defaultSideInfo);
    this.leftInfo = _.clone(defaultSideInfo);
  }



  getModalScreenMessage() {
    return this.modalScreenService.getMessage();
  }


}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/main-page/main-page.ts